import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
declare var $: any;
declare function InitChartHome(x: any): any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private util: UtilService,
    private apiService: ApiService) { }

  ngOnInit() {
    let that = this;
    // $("#btnMainConfirm").off('click');
    // $("#btnMainConfirm").click(async function () {
    //   await that.Save();
    // });
    // this.BeforeSearch();


  }
  BeforeSearch() {
    this.util.ShowWaiting(true);
    this.Search();
  }
  async  Search() {
    var data = {}
    var res: any = await this.apiService.post('Chart', 'GetDataHome', data);
    this.util.ShowWaiting(false);

    if (res.isSuccess) {
      if (res.responseData != null) {
        var obj = res.responseData;
        $('#lblS').html(obj.curr_data.sum_all);
        $('#lblR').html(obj.curr_data.sum_r);
        $('#lblB').html(obj.curr_data.sum_b);
        $('#lblV').html(obj.curr_data.sum_v_curr);
        $('#lblGarantor').html('Garantor letter as of ' + obj.garantor_date);
        InitChartHome(obj);
        if (obj.sum_w > 0) {
          $('#lblNumber').html('รายการรอทำจดหมายส่งสอบจำนวน ' + obj.sum_w + ' รายการ กรุณาตรวจสอบ');
          $('#dlgNoti').modal();
        }

      }
    }
  }


  ConfirmUpdate() {
   
    this.util.ConfirmDialog('Update ข้อมูล');
  }

  async Save() {


    let that = this;
    var data = {};
    that.util.ShowWaiting(true);
    var res: any = await this.apiService.post('chart', 'UpdateDashBoardReport', data, null);
    that.util.ShowWaiting(false);
    if (res != null) {
      if (res.isSuccess) {
        this.util.SuccessDialog('Update ข้อมูลสำเร็จ');
        this.Search();
      } else {
        this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
      }
    } else {
      this.util.ErrorDialog('System Error');
    }


  }
}



// WEBPACK FOOTER //
// ./src/app/home/home/home.component.ts